import { render, staticRenderFns } from "./OrganizationDevices.vue?vue&type=template&id=648c530d&"
import script from "./OrganizationDevices.vue?vue&type=script&lang=js&"
export * from "./OrganizationDevices.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationDevices.vue?vue&type=style&index=0&id=648c530d&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports